/*  MUI  */
import { Download, OpenInNew } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

/*  Shared  */
import Token from 'application/Shared/Components/CodeBlock/Token';
import { FontSizes } from 'application/Shared/Constants';
import { Token as TokenRequest } from 'application/Shared/Requests';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

/*  Constants  */
import IntegrationScriptFilename from './Constants/IntegrationScriptsFilename.json';

class NAble extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deploymentSteps: [],
            hasToken: false
        };

        /* requests */
        this.TokenRequest = new TokenRequest();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const partnerToken = await this.TokenRequest.getToken();

        if (partnerToken) {
            this.setState({ hasToken: true });
            this.setDeploymentSteps(partnerToken);
        }
    };

    unload = () => {
        this.TokenRequest.cancel();
    };

    setDeploymentSteps = async (token) => {
        const { t } = this.props;

        const deploymentSteps = [
            {
                component: (
                    <Typography variant="h4">
                        {t('Integrations.setup_process')}
                    </Typography>
                ),
                step: false
            },
            { note: t('Integrations.Nable.note'), step: false },
            { component: t('Integrations.Nable.step1'), step: true },
            {
                component: (
                    <Box
                        as="span"
                        display="inline-flex"
                        alignItems="baseline"
                        justifyContent="space-between"
                    >
                        <Box>{t('Integrations.Nable.step2')}</Box>
                        <Box ml="8px">
                            <a href={IntegrationScriptFilename.nableScript}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                >
                                    <Download
                                        style={{
                                            fontSize: FontSizes[2],
                                            marginRight: '4px'
                                        }}
                                    />
                                    {t('Integrations.Nable.script_filename')}
                                </Button>
                                .
                            </a>
                        </Box>
                    </Box>
                ),
                step: true
            },
            { component: t('Integrations.Nable.step3'), step: true },
            { component: t('Integrations.Nable.step4'), step: true },
            {
                component: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.Nable.step5')
                        }}
                    />
                ),
                step: true
            },
            {
                component: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.Nable.step6')
                        }}
                    />
                ),
                step: true
            },
            {
                component: (
                    <Box>
                        {t('Integrations.Nable.step7.part1')}
                        <ul style={{ paddingBottom: 0 }}>
                            <li className="li-with-spacing">
                                <Box
                                    display="inline-flex"
                                    alignItems="center"
                                    mt="8px"
                                >
                                    <span style={{ marginRight: '16px' }}>
                                        {t('Common.partner_token')}
                                    </span>
                                    <Token token={token} partner tokenOnly />
                                </Box>
                            </li>
                            <li className="li-with-spacing">
                                {t('Integrations.Nable.step7.client_name')}
                            </li>
                            <li className="li-with-spacing">
                                <Box display="flex" alignItems="center">
                                    <span>
                                        {t(
                                            'Integrations.Nable.step7.client_id'
                                        )}{' '}
                                        (
                                    </span>
                                    <a
                                        // eslint-disable-next-line max-len
                                        href="https://documentation.n-able.com/N-central/troubleshooting/Content/kb/Locate-a-customer-ID.htm#:~:text=Under%20the%20Service%20Organization%20Level,which%20is%20the%20Customer%20ID"
                                        target="_blank"
                                        rel="noopener noreferrer nofollow"
                                        className="link--secondary"
                                        style={{
                                            alignItems: 'center',
                                            display: 'flex'
                                        }}
                                    >
                                        <OpenInNew
                                            sx={{
                                                color: 'button.primary',
                                                fontSize: FontSizes[1],
                                                marginRight: '4px'
                                            }}
                                        />
                                        <span>{t('Common.documentation')}</span>
                                    </a>
                                    <span>)</span>
                                </Box>
                            </li>
                        </ul>
                    </Box>
                ),
                step: true
            },
            { component: t('Integrations.Nable.step8'), step: true },
            { component: t('Integrations.Nable.step9'), step: true },
            { component: t('Integrations.Nable.step10'), step: true }
        ];

        this.setState({ deploymentSteps });
    };

    render() {
        const { onboarding = false, session, t } = this.props;
        const { deploymentSteps, hasToken } = this.state;
        const userTheme = getUserTheme(session?.user?.theme);

        return (
            <IntegrationWrapper
                hasToken={hasToken}
                deploymentSteps={deploymentSteps}
                headerTitle={t('Integrations.Nable')}
                img={`/images/${userTheme}/integrations/n_able.png`}
                imgWidth="200px"
                onboarding={onboarding}
            />
        );
    }
}
export default withTranslation()(NAble);
